import { render, staticRenderFns } from "./AccessList.vue?vue&type=template&id=36570eb4&"
import script from "./AccessList.vue?vue&type=script&lang=js&"
export * from "./AccessList.vue?vue&type=script&lang=js&"
import style0 from "./AccessList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports